import { Container } from '../../components/ui';
import MedicoHeader from './MedicoHeader';
import TarjetaTurnoAgenda from './TarjetaTurnoAgenda';
import './Medico.css';

// Datos de ejemplo: esta pantalla es una maqueta (la integración no es requisito de esta entrega).
const TURNOS = [
  { id: 1, fecha: 'Lun 6 jul · 09:00 hs', estado: 'confirmado', paciente: 'María López', detalle: 'Consulta cardiológica · Sede Centro' },
  { id: 2, fecha: 'Mié 8 jul · 11:30 hs', estado: 'cambio', paciente: 'Jorge Díaz', detalle: 'Pidió mover el turno al Vie 10 jul · 11:30 hs' },
  { id: 3, fecha: 'Vie 10 jul · 14:00 hs', estado: 'confirmado', paciente: 'Carla Méndez', detalle: 'Consulta cardiológica · Sede Norte' },
];

export default function MedicoAgenda() {
  return (
    <Container>
      <MedicoHeader titulo="Mi agenda" />

      <h2 style={{ marginTop: 'var(--space-5)' }}>Próximos turnos</h2>
      <div className="medico-list">
        {TURNOS.map((t) => <TarjetaTurnoAgenda key={t.id} turno={t} />)}
      </div>
    </Container>
  );
}